import { Component, Input } from '@angular/core';
import { HxUiLabelPipe, StoreProductModel } from 'hx-services';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-store-product',
    templateUrl: './store-product.component.html',
    styleUrls: ['./store-product.component.css'],
  imports: [NgIf, HxUiLabelPipe]
})
export class StoreProductComponent {
  @Input() product!: StoreProductModel;
}
